import { render, staticRenderFns } from "./JSelectQingkaoXuesheng.vue?vue&type=template&id=0d923702&scoped=true"
import script from "./JSelectQingkaoXuesheng.vue?vue&type=script&lang=js"
export * from "./JSelectQingkaoXuesheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d923702",
  null
  
)

export default component.exports